<template>
  <div>
    <el-form  label-width="80px">
      <el-form-item label="邀请用户">
        <el-input placeholder="请输入用户电话" v-model="searchContent">
          <el-select style="width:120px" v-model="searchType" slot="prepend" placeholder="请选择">
<!--            <el-option label="用户id" value="1"></el-option>-->
            <el-option label="用户电话" value="2"></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item label="用户身份">
        <el-radio-group v-model="playRole" >
          <el-radio :label="0">开发人员</el-radio>
          <el-radio :label="1">用户</el-radio>
        </el-radio-group>
        <el-button style="margin-left: 100px" type="primary" @click="searchAddMember"> 添加用户 </el-button>
      </el-form-item>
    </el-form>
    <el-button  type="primary" @click="returnBack"> 返回公司用户列表 </el-button>
  </div>
</template>

<script>
import API from "../../../../config/api";

export default {
  data() {
    return {
      playRole: 0,  //记录邀请的用户的身份
      searchContent:'', //搜索框里面输入的内容
      searchId: '', //搜索的用户id
      searchTel: '',//搜索的用户电话
      searchType: '2', //搜索的类型
    }
  },
  props:{
    companyId:Number,
  },
  mounted() {
    this.userId = window.localStorage.getItem('userid');
    console.log('增加开发者userId的值=', this.userId);
    console.log(this.companyId)
  },
  methods: {
    //返回公司用户列表
    returnBack(){
      this.$emit("returnBack")
    },
    //根据id或者电话号码邀请用户
    searchAddMember() {
      if (this.searchContent === "") {
        this.$message({type: 'warning', message: '请输入用户电话'});
        return
      }
      if(this.searchType == '1'){
        this.searchId = this.searchContent;
        this.searchTel = null;
      }
      if(this.searchType == '2'){
        this.searchTel = this.searchContent;
        this.searchId = null;
      }
      let self = this;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
        userId:this.searchId,
        bindingTel: this.searchTel,
        role_type:this.playRole,
      }
      // 获取非当前用户的其他所有用户
      this.$axiosRequest({
        url: API.insertCompanyUser,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data == 1) {
            self.$message({type: 'success', message: '已成功发出邀请'});
            self.$emit("returnBack")
          } else if (res.data == 0) {
            self.$message({type: 'warning', message: '该用户已和公司存在关联'});
          } else if (res.data == 2) {
            self.$message({type: 'warning', message: '该用户不存在'});
          } else if (res.data == -1) {
            self.$message({type: 'warning', message: '程序错误'});
          }
        }
      });
    },

  }
}
</script>

<style lang="less" scoped>
swiper {
  height: 400px;

  image {
    width: 100%;
  }
}

.info-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  padding: 24px;
}

.info-content {
  margin: 10px 0px 10px 10px; // 上 右 下 左
  height: auto;
}

.title-style {
  font-size: 18px;
  font-weight: bold;
}

.title2-style {
  font-size: 15px;
  font-weight: bold;
  line-height: 40px;
}

</style>
